import React from "react";
//
// dont touch any order - kea is crazy

import { render } from "react-dom";
//

import { Provider } from "react-redux";

//
import { Router, browserHistory } from "react-router";

//
import { syncHistory } from "redux-simple-router";

//
import * as configureStoreMethods from "./storeConfiguration";
//
import routes from "./routes";
//
import "../../Content/Less/main.less";
//
import "../../Content/css/animate.min.css";

//
import client from "../Globals/sentry";

//
import { PersistGate } from "redux-persist/integration/react";

if (!/Mobi/.test(navigator.userAgent)) {
  // Create the <style> tag
  var style = document.createElement("style");

  style.appendChild(
    document.createTextNode(".wavesHover:hover {color: rgb(58, 130, 156);}")
  );

  document.head.appendChild(style);
}

const initialState = {}; //window.__INITIAL_STATE__;

var configureStore;
switch (process.env.REACT_APP_env) {
  case "development":
    configureStore = configureStoreMethods.configureStoreDev;
    break;
  case "staging":
    configureStore = configureStoreMethods.configureStoreDev;
    break;
  default:
    configureStore = configureStoreMethods.configureStoreProd;
}

// Sync dispatched route actions to the history
const reduxRouterMiddleware = syncHistory(browserHistory);

const { store, persistor } = configureStore(
  initialState,
  reduxRouterMiddleware
);

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={browserHistory}>{routes}</Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/App/MainClient/index.jsx